import { render, staticRenderFns } from "./DrugAddItem.vue?vue&type=template&id=612b6852&lang=pug"
import script from "./DrugAddItem.vue?vue&type=script&lang=js"
export * from "./DrugAddItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrugExternalLinks: require('/home/docker/code/frontend/components/DrugExternalLinks.vue').default,DrugExternalCosts: require('/home/docker/code/frontend/components/DrugExternalCosts.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,DrugForm: require('/home/docker/code/frontend/components/DrugForm.vue').default})
